/*
 * Ken Heang - theme scripts (the PHP site's custom-scripts.js for WordPress).
 * WordPress loads jQuery in noConflict mode, so $ is passed in. The active menu item comes from WordPress
 * (li.active), so the PHP site's URL matching is not needed.
 */
(function ($) {
  'use strict';

  $(function () {
    //===== Width =====//
    var width = window.innerWidth;

    //===== Wow Animation Setting =====//
    if ($('.wow').length > 0 && typeof WOW !== 'undefined') {
      var wow = new WOW({
        boxClass:     'wow',
        animateClass: 'animated',
        offset:       0,
        mobile:       true,
        live:         true
      });
      wow.init();
    }

    //===== Side Menu =====//
    function openMenu() {
      $('.rsnp-mnu').addClass('slidein');
      $('.menu-overlay').addClass('show');
    }
    function closeMenu() {
      $('.rsnp-mnu').removeClass('slidein');
      $('.menu-overlay').removeClass('show');
    }
    $('.rspn-mnu-btn').on('click', function () {
      openMenu();
      return false;
    });
    $('.rspn-mnu-cls, .menu-overlay').on('click', closeMenu);
    $('.rspn-mnu-btn, .rspn-mnu-cls').on('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        $(this).trigger('click');
      }
    });
    $(document).on('keydown', function (e) {
      if (e.key === 'Escape') { closeMenu(); }
    });
    $('.rsnp-mnu li.menu-item-has-children > a').on('click', function () {
      $(this).parent().siblings('li').children('ul').slideUp();
      $(this).parent().siblings('li').removeClass('active');
      $(this).parent().children('ul').slideToggle();
      $(this).parent().toggleClass('active');
      return false;
    });

    //===== LightBox =====//
    if ($.isFunction($.fn.fancybox)) {
      $('[data-fancybox]').fancybox({
        buttons: ['zoom', 'close']
      });
    }

    //===== Slick Carousel =====//
    if ($.isFunction($.fn.slick)) {

      //=== Testimonials Carousel ===//
      $('.testi-caro').slick({
        arrows: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 800,
        draggable: true,
        dots: false,
        pauseOnHover: true,
        prevArrow: $('.testi-prev'),
        nextArrow: $('.testi-next'),
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
              arrows: false
            }
          }
        ]
      });
    }

    //===== Scrollbar on responsive menu =====//
    if (width < 992 && typeof PerfectScrollbar !== 'undefined') {
      if ($('.rsnp-mnu').length > 0) {
        new PerfectScrollbar('.rsnp-mnu');
      }
    }

    //===== Smooth scroll for anchors =====//
    $('a[href^="#"]').not('[data-fancybox], .skip-link').on('click', function (e) {
      var target = $(this).attr('href');
      if (target.length > 1 && $(target).length) {
        e.preventDefault();
        $('html, body').animate({ scrollTop: $(target).offset().top - 60 }, 700);
      }
    });

    //===== Scroll to top =====//
    $('.scroll-top').on('click', function (e) {
      e.preventDefault();
      $('html, body').animate({ scrollTop: 0 }, 700);
    });
  });

  //===== Sticky Header =====//
  $(window).on('scroll', function () {
    var scroll = $(window).scrollTop();
    var menu_height = $('header').outerHeight() || 90;
    if (scroll >= menu_height) {
      $('body').addClass('sticky');
    } else {
      $('body').removeClass('sticky');
    }
    if (scroll > 400) {
      $('.scroll-top').addClass('show');
    } else {
      $('.scroll-top').removeClass('show');
    }
  });
})(jQuery);
